import { useEffect, useState } from "react";
import PropTypes from "prop-types";

import ActionButton from "../formInputs/buttons/ActionButton";
import DcsdDialog from "../modals/DcsdDialog";
import Icon from "../icon/Icon";
import T from "../translations/Translations";

import { gradeTranslator } from "../../const/Translations";

import "../../styles/GradeLevelBlock.scss";

/**
 * A component that will render a set of text with 2 boxes, current grade and applying grade
 * @name GradeBlock
 * @param {{}} formState
 * @returns {JSX.Element}
 */
const GradeBlock = ({ formDispatch, formState, schoolYearRange, studentIcData }) => {
    const [canReapply, setCanReapply] = useState(false);
    const [open, setOpen] = useState("false");
    const [reapplyChecked, setReapplyChecked] = useState(false);

    const oeButtonsCancel = T({ key: "OE_Buttons_Cancel" });
    const oeButtonsContinue = T({ key: "OE_Buttons_Continue" });
    const oeFormAppForGrade = T({ key: "OE_Form_App_For_Grade" });
    const oeFormAppForGrade1 = T({ key: "OE_Form_App_For_Grade_Description1" });
    const oeFormAppForGrade2 = T({ key: "OE_Form_App_For_Grade_Description2" });
    const oeFormAppForGrade3 = T({ key: "OE_Form_App_For_Grade_Description3" });
    const oeFormCurrentGrade = T({ key: "OE_Form_Current_Grade" });
    const oeFormApplyingForGrade = T({ key: "OE_Form_Applying_For_Grade" });
    const oeFormApplyingForKindergarten = T({ key: "OE_Form_Applying_For_Kindergarten" });
    const oeFormApplyingForKinderTitle = T({ key: "OE_Form_Applying_For_Kinder_Title" });
    const oeFormApplyingForKinderBody = T({ key: "OE_Form_Applying_For_Kinder_Body" });

    const setGradeFields = (reapply = false) => {
        const tmpFormState = formState;

        tmpFormState.gradeName = reapply ? "PRE" : "K";
        tmpFormState.gradeApplying = reapply ? "K" : "FIRST";

        formDispatch({
            type: "reset",
            payload: { ...tmpFormState }
        });
        setReapplyChecked(reapply);
        setOpen("false");
    };

    const getReapplyActions = () => {
        return (
            <>
                <ActionButton
                    className="action-button-cancel"
                    label={oeButtonsCancel}
                    onClick={() => {
                        setGradeFields();
                    }}
                />
                <ActionButton
                    className="action-button-delete"
                    label={oeButtonsContinue}
                    onClick={() => {
                        setGradeFields(true);
                    }}
                />
            </>
        );
    };

    const handleReapplyChange = (e) => {
        setReapplyChecked(e.target.checked);
        if (e.target.checked) {
            setOpen("reapply");
        } else {
            setGradeFields();
        }
    };

    /**
     * If the student is not IC and gradeApplying is 01, allow the user to re-apply to K
     */
    useEffect(() => {
        if (formState.gradeApplying === "FIRST") {
            setCanReapply(!studentIcData);
        }
    }, [formState.gradeApplying, studentIcData]);

    if (formState.gradeApplying && formState.gradeName) {
        return (
            <div>
                <div className="top-label grade-gutter-90">{oeFormAppForGrade}:</div>
                <div className="top-label-secondary-text grade-gutter-90">
                    <span className="will-be">
                        {oeFormAppForGrade1} <span className="bold">{schoolYearRange?.name}</span> {oeFormAppForGrade2},
                    </span>{" "}
                    {oeFormAppForGrade3}
                </div>
                <div className="applying-grade-container grade-gutter-90">
                    <div className="outer">
                        <p>{oeFormCurrentGrade}</p>
                        <div className="current-grade-number">{gradeTranslator(formState.gradeName)}</div>
                    </div>
                    <Icon
                        className="spaceLeft-spaceRight"
                        fill="#707070"
                        height={50}
                        iconName="RIGHT_ARROW_IN_CIRCLE"
                        width={50}
                    />
                    <div className="outer">
                        <p>{oeFormApplyingForGrade}</p>
                        <div className="applying-grade-number">{gradeTranslator(formState.gradeApplying)}</div>
                    </div>
                </div>
                {canReapply && (
                    <>
                        <br />
                        <br />
                        <div className="reapply grade-gutter-90">
                            <label htmlFor="reapply" className="reapply-label">
                                <input
                                    type="checkbox"
                                    id="reapply"
                                    checked={reapplyChecked}
                                    onChange={handleReapplyChange}
                                    style={{ margin: "10px", transform: "scale(1.7)" }}
                                />{" "}
                                <span className="reapply-text">{oeFormApplyingForKindergarten}</span>
                            </label>
                        </div>
                    </>
                )}
                <DcsdDialog
                    actions={getReapplyActions()}
                    ariaLabel="Applying for Kindergarten Confirmation Dialog"
                    hasCloseX={false}
                    id="reapply"
                    onHide={() => {
                        setOpen("false");
                    }}
                    open={open}
                    title={oeFormApplyingForKinderTitle}
                >
                    <p>{oeFormApplyingForKinderBody}</p>
                </DcsdDialog>
            </div>
        );
    }

    return null;
};

GradeBlock.propTypes = {
    formDispatch: PropTypes.func.isRequired,
    formState: PropTypes.oneOfType([PropTypes.object]).isRequired,
    schoolYearRange: PropTypes.oneOfType([PropTypes.object]).isRequired,
    studentIcData: PropTypes.oneOfType([PropTypes.object])
};

GradeBlock.defaultProps = {
    studentIcData: null
};

export default GradeBlock;
